export const REPORTING_INHOUSE_DSPS = ["2", "3", "3454", "3599"];
export const BANNER_PREVIEW_AES_PASSWORD = "neptuneailokeshm";
export const BANNER_PREVIEW_URL =
  "https://nep.advangelists.com/xp/preview?width={WIDTH}&height={HEIGHT}&crid={AES_BANNER_ID}&displaytype={BANNER_TYPE}";

export const DOMAIN_PREVIEW_URLS = {
  "goadfuel.net":
    "https://nep.goadfuel.net/xp/preview?width={WIDTH}&height={HEIGHT}&crid={AES_BANNER_ID}&displaytype={BANNER_TYPE}",
};

export const CONFIGURATIONS = {
  createaudience: [
    {
      name: "Details",
      id: 1,
    },
    {
      name: "Location Group",
      id: 2,
    },
    {
      name: "CRM",
      id: 3,
    },
    {
      name: "Lookup Window",
      id: 4,
    },
  ],
  supplyanalysis: [
    {
      name: "Details",
      id: 1,
    },
    {
      name: "Location Group",
      id: 2,
    },
    {
      name: "Inventory",
      id: 5,
    },
    {
      name: "Device / OS",
      id: 6,
    },
    {
      name: "Demographic",
      id: 7,
    },
  ],
  privatemarketplace: [
    {
      name: "Details",
      id: 1,
    },
    {
      name: "Location Group",
      id: 2,
    },
    {
      name: "Inventory",
      id: 5,
    },
    {
      name: "Device / OS",
      id: 6,
    },
    {
      name: "Demographic",
      id: 7,
    },
  ],
  demandpartners: [
    {
      name: "Details",
      id: 1,
    },
    {
      name: "Location Group",
      id: 2,
    },
    {
      name: "Inventory",
      id: 5,
    },
    {
      name: "Device/OS",
      id: 6,
    },
    {
      name: "Demographic",
      id: 7,
    },
  ],
  campaigns: [
    {
      name: "Details",
      id: 1,
    },
    {
      name: "Additional Details",
      id: 8,
    },
    {
      name: "Goals",
      id: 9,
    },
    {
      name: "Location Group",
      id: 2,
    },
    {
      name: "Inventory",
      id: 5,
    },
    {
      name: "Device/OS",
      id: 6,
    },
    {
      name: "Demographic",
      id: 7,
    },
  ],
  labels: {
    createaudience: {
      configuration: "Segment Configuration",
      pointer: "Segment",
    },
    supplyanalysis: {
      configuration: "Supply Analysis Configuration",
      pointer: "Supply Analysis",
    },
    privatemarketplace: {
      configuration: "Private Market Configuration",
      pointer: "Private Market Place",
    },
    demandpartners: {
      configuration: "Demand Partner Configuration",
      pointer: "Demand Partner",
    },
    campaigns: {
      configuration: "Campaign Configuration",
      pointer: "Campaign",
    },
    1824: "18-24",
    2534: "25-34",
    3549: "35-49",
    50: "50+",
    male: "Male",
    female: "Female",
    other: "Other",
    app: "APP",
    web: "WEB",
    ctv: "CTV",
    mobile: "Mobile",
    portrait: "Portrait",
    landscape: "Landscape",
    android: "Android",
    ios: "IOS",
    wifi: "WiFi / Broadband",
  },
  defaultValues: {
    platforms: {
      ctv: false,
      mobile: false,
      web: false,
    },
    orientation: {
      portrait: false,
      landscape: false,
    },
    os: {
      android: false,
      ios: false,
      other: false,
    },
    connection: {
      mobile: false,
      wifi: false,
    },
    language: {
      list: [],
      include: true,
    },
    traffic: {
      app: false,
      web: false,
    },
    ageGroups: {
      1824: false,
      2534: false,
      3549: false,
      50: false,
    },
    gender: {
      male: false,
      female: false,
      other: false,
    },
    categories: {
      list: [],
      include: true,
    },
    publishers: {
      list: [],
      include: true,
    },
    placementIds: {
      list: [],
      include: true,
    },
  },
};
export const AdTargetSizes = {
  banner: {
    "320x50,300x50": "320x50",
    "320x100,300x100": "300x100",
    "300x250,320x250": "300x250",
    "320x480,480x320": "320x480",
    "728x90,90x728": "728x90",
    "1024x768,768x1024": "1024x768",
    "320x568,568x320": "320x568",
    "160x600,600x160": "160x600",
    "300x600,600x300": "300x600",
    "250x250,250x250": "250x250",
    "200x200,200x200": "200x200",
    "720x1280,1280x720": "720x1280",
  },
  video: {
    "300x250,320x250": "Small",
    "320x480,480x320": "Medium",
    "1024x768,768x1024": "Large",
  },
  native: {
    "1x1": "1x1",
  },
  native_video: {
    "1x1": "1x1",
  },
};

export const inventoryFields = {
  App: {
    label: "Inventory Type",
    value: "ssp",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Select Inventory Type",
    id: "",
    delete: false,
  },
  AppUrl: {
    label: "App Url",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "url",
    default_msg: "Enter Url",
    details: "",
  },
  placementfields: [],
};
export const placementFields = {
  PlacementName: {
    label: "Name",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Enter Placement Name",
    id: "",
    delete: false,
  },
  PartnerTagId: {
    label: "Partner Tag Id",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Enter Partner Tag Id",
  },
  OverrideFloorSetting: {
    label: "override Floor Setting",
    value: false,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "checkbox",
    default_msg: "check",
  },
  countryWiseFields: [],
};

export const countryWiseFloorFields = {
  Country: {
    label: "Country",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Select Country",
  },
  adSizes: {
    banner: {
      "320x50,300x50": 0,
      "320x100,300x100": 0,
      "300x250,320x250": 0,
      "320x480,480x320": 0,
      "728x90,90x728": 0,
      "1024x768,768x1024": 0,
      "320x568,568x320": 0,
      "160x600,600x160": 0,
      "300x600,600x300": 0,
      "250x250,250x250": 0,
      "200x200,200x200": 0,
      "720x1280,1280x720": 0,
    },
    video: {
      "300x250,320x250": 0,
      "320x480,480x320": 0,
      "1024x768,768x1024": 0,
    },
    native: {
      "1x1": 0,
    },
    native_video: {
      "1x1": 0,
    },
  },
};

export const crmFields = {
  Crm: {
    label: "Crm",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Select Crm",
    id: "",
    delete: false,
  },
  CredentialJson: {
    label: "Credential Json",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Enter Credential Json",
  },
  DatabaseUrl: {
    label: "Database Url",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Enter Datebase Url",
  },
  TableName: {
    label: "Table Name",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Enter Table Name",
  },
};

export const LocationGroupFields = {
  IsComplete: {
    label: "",
    value: false,
  },
  Id: {
    label: "Id",
    value: "",
  },
  Name: {
    label: "Name",
    value: "Location group",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Enter Name",
    action: "add",
  },
  City: {
    label: "City",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select City",
  },
  State: {
    label: "State",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select State",
  },
  DMA: {
    label: "DMA",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select DMA",
  },
  Counties: {
    label: "Counties",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Counties",
  },
  Zipcode: {
    label: "Zipcode",
    value: [],
    error: false,
    message: "",
    include: true,
    touched: false,
    required: false,
    type: "",
    default_msg: "Enter Zipcode",
  },
  LatLon: {
    label: "Lat / Long",
    value: [],
    files: [],
    inactive_values: [],
    preview_values: [],
    records: 0,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Upload Lat / Long",
  },
  LatLonRadius: {
    label: "Radius",
    value: 5,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Addresses: {
    label: "Addresses",
    value: [],
    files: [],
    preview_values: [],
    records: 0,
    error: false,
    message: "",
    //include: false,
    touched: false,
    required: false,
    type: "",
    default_msg: "Enter Addresses",
  },
  AddressRadius: {
    label: "Radius",
    value: 5,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  PlacesPoiLocations: {
    label: "Places / POI Locations",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Places / POI Locations",
  },
  Brands: {
    label: "Brands",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Brand",
  },
  POI: {
    label: "POI",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select POI",
  },
  POIRadius: {
    label: "POI Radius",
    value: 5,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Polygons: {
    label: "Polygons",
    value: [],
    files: [],
    inactive_values: [],
    preview_values: [],
    records: 0,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  SenateDistricts: {
    label: "Senate Districts",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Senate Districts",
  },
  HouseDistricts: {
    label: "House Districts",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select House Districts",
  },
  CongDistricts: {
    label: "Congressional Districts",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Congressional Districts",
  },
  MinDays: {
    label: "Min Days",
    value: "",
  },
  MinVisits: {
    label: "Min Visits",
    value: "",
  },
  ZipcodeGroup: {
    label: "Zipcode Group",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  IPAddressGroup: {
    label: "IP Address Group",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    include: true,
    type: "",
    default_msg: "",
  },
  LatLonGroup: {
    label: "Lat / Long Group",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  AddressGroup: {
    label: "Address Groups",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  PolygonGroup: {
    label: "Polygon Groups",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Email: {
    label: "Email",
    value: [],
    error: false,
    message: "",
    include: true,
    touched: false,
    required: false,
    type: "",
    default_msg: "Enter Email",
  },
  EmailGroup: {
    label: "Email Group",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Context: {
    label: "Context",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Describe what you're looking for...",
  },
  ContextKeywords: {
    label: "Context Keywords",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
};
export const BannerLocationGroupFields = {
  Id: {
    label: "Id",
    value: "",
  },
  IsDeleted: {
    label: "Delete",
    value: false,
  },
  IsLoaded: {
    label: "Is Loaded",
    value: false,
  },
  IsComplete: {
    label: "Is IsComplete",
    value: false,
  },
  Name: {
    label: "Name",
    value: "banner Location group",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Enter Name",
    action: "add",
  },
  City: {
    label: "City",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Select City",
  },
  State: {
    label: "State",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Select State",
  },
  DMA: {
    label: "DMA",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Select DMA",
  },
  Counties: {
    label: "Counties",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Counties",
  },
  Zipcode: {
    label: "Zipcode",
    value: [],
    error: false,
    message: "",
    include: true,
    touched: false,
    required: true,
    type: "",
    default_msg: "Enter Zipcode",
  },
  LatLon: {
    label: "Lat / Long",
    value: [],
    files: [],
    inactive_values: [],
    preview_values: [],
    records: 0,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Upload Lat / Long",
  },
  LatLonRadius: {
    label: "Radius",
    value: 5,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Addresses: {
    label: "Addresses",
    value: [],
    files: [],
    preview_values: [],
    records: 0,
    error: false,
    message: "",
    //include: false,
    touched: false,
    required: false,
    type: "",
    default_msg: "Enter Addresses",
  },
  AddressRadius: {
    label: "Radius",
    value: 5,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  PlacesPoiLocations: {
    label: "Places / POI Locations",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Places / POI Locations",
  },
  Brands: {
    label: "Brands",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Brand",
  },
  POI: {
    label: "POI",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select POI",
  },
  POIRadius: {
    label: "POI Radius",
    value: 5,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Polygons: {
    label: "Polygons",
    value: [],
    files: [],
    inactive_values: [],
    preview_values: [],
    records: 0,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  SenateDistricts: {
    label: "Senate Districts",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Senate Districts",
  },
  HouseDistricts: {
    label: "House Districts",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select House Districts",
  },
  CongDistricts: {
    label: "Congressional Districts",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Congressional Districts",
  },
  ZipcodeGroup: {
    label: "Zipcode Group",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  IPAddressGroup: {
    label: "IP Address Group",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    include: true,
    type: "",
    default_msg: "",
  },
  LatLonGroup: {
    label: "Lat / Long Group",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  AddressGroup: {
    label: "Address Groups",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  PolygonGroup: {
    label: "Polygon Groups",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
};
export const campaignBannerFields = {
  ID: {
    label: "ID",
    value: "",
    others: {
      target_pub: "",
      target_placements: "",
      target_supply_deal_id: "",
      target_bundles: "",
    },
    preview_link: "",
  },
  Status: {
    value: 0,
  },
  isDeleted: { value: false },
  HasCampaignTargeting: { value: 0 },
  Name: {
    label: "Name",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "Enter Creative Name",
  },
  BannerType: {
    label: "Banner Type",
    value: "image",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "",
    default_msg: "",
  },
  JSBannerSize: {
    label: "Banner Size",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  AdMarkup: {
    label: "Ad Markup",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  ImageSize: {
    label: "Image Size",
    value: "320x50,300x50",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  ImageURL: {
    label: "Image URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "image_url",
    default_msg: "",
  },
  UploadImageType: {
    label: "Upload Image Type",
    value: "1",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  UploadedImageURL: {
    label: "Uploaded Image",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  UploadVideoType: {
    label: "Upload Video Type",
    value: "2",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  ClickURL: {
    label: "Click URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "url",
    default_msg: "",
  },
  VideoURL: {
    label: "Video URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    html: "",
    type: "video_url",
    default_msg: "",
  },
  VastURL: {
    label: "VAST URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "url",
    default_msg: "",
  },
  CacheExpiry: {
    label: "Cache Expiry",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  VideoSizes: {
    label: "Video Sizes",
    value: [],
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  UploadedVideoURL: {
    label: "Upload Video",
    value: "",
    error: false,
    message: "",
    videoInfo: {},
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  LandingPageURL: {
    label: "Landing Page URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "url",
    default_msg: "",
  },
  IconImageURL: {
    label: "Icon Image URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "image_url",
    default_msg: "",
  },
  UploadIconImageType: {
    label: "Upload Icon Image Type",
    value: "1",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  UploadedIconImageURL: {
    label: "Uploaded Icon Image",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  SmallImageURL: {
    label: "Small Image URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "image_url",
    default_msg: "",
  },
  UploadSmallImageType: {
    label: "Upload Small Image Type",
    value: "1",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  UploadedSmallImageURL: {
    label: "Uploaded Small Image",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  LargeImageURL: {
    label: "Large Image URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: true,
    type: "image_url",
    default_msg: "",
  },
  UploadLargeImageType: {
    label: "Upload Large Image Type",
    value: "1",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  UploadedLargeImageURL: {
    label: "Uploaded Large Image",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Description: {
    label: "Description",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Title: {
    label: "Title",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Sponsored: {
    label: "Sponsored ",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  CTAText: {
    label: "CTA Text",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Rating: {
    label: "Rating",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Likes: {
    label: "Likes",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Downloads: {
    label: "Downloads",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Price: {
    label: "Price",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  SalePrice: {
    label: "Sale Price",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Phone: {
    label: "Phone",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Address: {
    label: "Address",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  Description2: {
    label: "Description 2",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  DisplayURL: {
    label: "Display URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  PrivacyURL: {
    label: "Privacy URL",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "url",
    default_msg: "",
  },
  HTML: {
    label: "HTML",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  DailyClicks: {
    label: "Daily Clicks",
    value: null,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  DailyClicksType: {
    label: "Daily Clicks Type",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  DailyClicksGoalType: {
    label: "Daily Clicks Goal Type",
    value: "percentage",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Goal Type",
  },

  DailyImpressions: {
    label: "Daily Impressions",
    value: null,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  DailyImpressionsType: {
    label: "Daily Impressions Type",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  DailyImpressionsGoalType: {
    label: "Daily Impressions Goal Type",
    value: "percentage",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Goal Type",
  },

  DailyCompletesType: {
    label: "Daily Completes Type",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  DailyCompletesGoalType: {
    label: "Daily Completes Goal Type",
    value: "percentage",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Goal Type",
  },
  DailyCompletes: {
    label: "Daily Vedio Completes",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  TotalImpressionsType: {
    label: "Life Time Impressions Type",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  TotalImpressionsGoalType: {
    label: "Life Time Impressions Goal Type",
    value: "percentage",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Goal Type",
  },
  TotalImpressions: {
    label: "Lifetime Impressions",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  TotalClicksType: {
    label: "Life Time Click Type",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  TotalClicksGoalType: {
    label: "Life Time Clicks Goal Type",
    value: "percentage",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Goal Type",
  },
  TotalClicks: {
    label: "Lifetime Clicks",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },

  TotalCompletesType: {
    label: "Life Time Completes Type",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  TotalCompletesGoalType: {
    label: "Life Time Clicks Goal Type",
    value: "percentage",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "Select Goal Type",
  },
  TotalCompletes: {
    label: "Lifetime Completes",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  HardDailyLimit: {
    label: "Hard Daily Limits",
    value: 0,
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "zero",
    default_msg: "",
  },
  CustomScripts: {
    label: "Custom Scripts",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  ImpressionsUrl: {
    label: "Impression URLs",
    value: "",
    error: false,
    message: "",
    touched: false,
    required: false,
    type: "",
    default_msg: "",
  },
  IsTargetingSetAdded: false,
  TargetingSets: [
    {
      name: "Goals",
      id: 0,
      fields: {
        /*******Goals Section Fields******* */
        DailyClicks: {
          label: "Daily Clicks",
          value: null,
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        DailyClicksType: {
          label: "Daily Clicks Type",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        DailyClicksGoalType: {
          label: "Daily Clicks Goal Type",
          value: "percentage",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "Select Goal Type",
        },

        DailyImpressions: {
          label: "Daily Impressions",
          value: null,
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        DailyImpressionsType: {
          label: "Daily Impressions Type",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        DailyImpressionsGoalType: {
          label: "Daily Impressions Goal Type",
          value: "percentage",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "Select Goal Type",
        },

        DailyCompletesType: {
          label: "Daily Completes Type",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        DailyCompletesGoalType: {
          label: "Daily Completes Goal Type",
          value: "percentage",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "Select Goal Type",
        },
        DailyCompletes: {
          label: "Daily Vedio Completes",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },

        /****For Lofetime campaign */

        TotalImpressionsType: {
          label: "Life Time Impressions Type",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        TotalImpressionsGoalType: {
          label: "Life Time Impressions Goal Type",
          value: "percentage",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "Select Goal Type",
        },
        TotalImpressions: {
          label: "Lifetime Impressions",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        TotalClicksType: {
          label: "Life Time Click Type",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        TotalClicksGoalType: {
          label: "Life Time Clicks Goal Type",
          value: "percentage",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "Select Goal Type",
        },
        TotalClicks: {
          label: "Lifetime Clicks",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },

        TotalCompletesType: {
          label: "Life Time Completes Type",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        TotalCompletesGoalType: {
          label: "Life Time Clicks Goal Type",
          value: "percentage",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "Select Goal Type",
        },
        TotalCompletes: {
          label: "Lifetime Completes",
          value: "",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },

        HardDailyLimit: {
          label: "Hard Daily Limits",
          value: 0,
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "zero",
          default_msg: "",
        },
      },
    },
    {
      name: "Location Group",
      id: 1,
      isLocationDataLoaded: false,
      fields: [BannerLocationGroupFields],
    },
    {
      name: "Inventory",
      id: 2,
      isInventoryDataLoaded: false,
      fields: {
        Language: {
          label: "Language",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "Select Language",
        },
        target_app: {
          label: "App / Web",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "zero",
          default_msg: "",
        },
        target_skippable: {
          label: "Skippable",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        Categories: {
          label: "Categories",
          value: [],
          error: false,
          message: "",
          include: true,
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        Publishers: {
          label: "Publishers",
          value: [],
          error: false,
          include: true,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        Placements: {
          label: "Placement Ids",
          value: [],
          error: false,
          include: true,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        SupplyDeals: {
          label: "Supply Deal IDs",
          value: [],
          error: false,
          include: true,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        BundleIds: {
          label: "Bundle IDs",
          value: [],
          error: false,
          include: true,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
      },
    },
    {
      name: "Device / OS",
      id: 3,
      fields: {
        target_devicetype: {
          label: "Platforms",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        target_orientation: {
          label: "Orientation",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "zero",
          default_msg: "",
        },
        target_device_os: {
          label: "OS",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "zero",
          default_msg: "",
        },
        target_connectiontype: {
          label: "Connection Type",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
      },
    },
    {
      name: "Demographic",
      id: 4,
      fields: {
        target_gender: {
          label: "Gender",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        target_age: {
          label: "Age Groups",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
      },
    },
    {
      name: "Audience",
      id: 5,
      fields: {
        segmentType: {
          label: "Segment Type",
          value: "1",
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        GlobalSegments: {
          label: "Global Segments ",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        CustomSegments: {
          label: "Custom Segments ",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        CustomSegmentsPreview: {
          label: "Custom Segments ",
          value: {
            orGroup: [],
          },
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        SelectedSegments: {
          label: "Segments",
          // value: {
          //   microssp: { orGroup: [] },
          //   mobiquity: { orGroup: [] },
          // },
          value: {},
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
      },
    },
    {
      name: "Miscellaneous",
      id: 6,
      fields: {
        target_days: {
          label: "Days Of Week",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
        target_hours: {
          label: "Day Of Hours",
          value: [],
          error: false,
          message: "",
          touched: false,
          required: false,
          type: "",
          default_msg: "",
        },
      },
    },
  ],
};
export const BannerTargetingStepFields = [
  {
    name: "Goals",
    id: 0,
    fields: {
      /*******Goals Section Fields******* */
      DailyClicks: {
        label: "Daily Clicks",
        value: null,
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      DailyClicksType: {
        label: "Daily Clicks Type",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      DailyClicksGoalType: {
        label: "Daily Clicks Goal Type",
        value: "percentage",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "Select Goal Type",
      },

      DailyImpressions: {
        label: "Daily Impressions",
        value: null,
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      DailyImpressionsType: {
        label: "Daily Impressions Type",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      DailyImpressionsGoalType: {
        label: "Daily Impressions Goal Type",
        value: "percentage",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "Select Goal Type",
      },

      DailyCompletesType: {
        label: "Daily Completes Type",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      DailyCompletesGoalType: {
        label: "Daily Completes Goal Type",
        value: "percentage",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "Select Goal Type",
      },
      DailyCompletes: {
        label: "Daily Vedio Completes",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },

      /****For Lofetime campaign */

      TotalImpressionsType: {
        label: "Life Time Impressions Type",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      TotalImpressionsGoalType: {
        label: "Life Time Impressions Goal Type",
        value: "percentage",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "Select Goal Type",
      },
      TotalImpressions: {
        label: "Lifetime Impressions",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      TotalClicksType: {
        label: "Life Time Click Type",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      TotalClicksGoalType: {
        label: "Life Time Clicks Goal Type",
        value: "percentage",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "Select Goal Type",
      },
      TotalClicks: {
        label: "Lifetime Clicks",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },

      TotalCompletesType: {
        label: "Life Time Completes Type",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      TotalCompletesGoalType: {
        label: "Life Time Clicks Goal Type",
        value: "percentage",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "Select Goal Type",
      },
      TotalCompletes: {
        label: "Lifetime Completes",
        value: "",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },

      HardDailyLimit: {
        label: "Hard Daily Limits",
        value: 0,
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "zero",
        default_msg: "",
      },
    },
  },
  {
    name: "Location Group",
    id: 1,
    isLocationDataLoaded: false,
    fields: [BannerLocationGroupFields],
  },
  {
    name: "Inventory",
    id: 2,
    isInventoryDataLoaded: false,
    fields: {
      Language: {
        label: "Language",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "Select Language",
      },
      target_app: {
        label: "App / Web",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "zero",
        default_msg: "",
      },
      target_skippable: {
        label: "Skippable",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      Categories: {
        label: "Categories",
        value: [],
        error: false,
        message: "",
        include: true,
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      Publishers: {
        label: "Publishers",
        value: [],
        error: false,
        include: true,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      Placements: {
        label: "Placement Ids",
        value: [],
        error: false,
        include: true,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      SupplyDeals: {
        label: "Supply Deal IDs",
        value: [],
        error: false,
        include: true,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      BundleIds: {
        label: "Bundle IDs",
        value: [],
        error: false,
        include: true,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
    },
  },
  {
    name: "Device/OS",
    id: 3,
    fields: {
      target_devicetype: {
        label: "Platforms",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      target_orientation: {
        label: "Orientation",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "zero",
        default_msg: "",
      },
      target_device_os: {
        label: "OS",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "zero",
        default_msg: "",
      },
      target_connectiontype: {
        label: "Connection Type",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
    },
  },
  {
    name: "Demographic",
    id: 4,
    fields: {
      target_gender: {
        label: "Gender",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      target_age: {
        label: "Age Groups",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
    },
  },
  {
    name: "Audience",
    id: 5,
    fields: {
      segmentType: {
        label: "Segment Type",
        value: "1",
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      GlobalSegments: {
        label: "Global Segments ",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      CustomSegments: {
        label: "Custom Segments ",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      CustomSegmentsPreview: {
        label: "Custom Segments ",
        value: {
          orGroup: [],
        },
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      SelectedSegments: {
        label: "Segments",
        // value: {
        //   microssp: { orGroup: [] },
        //   mobiquity: { orGroup: [] },
        // },
        value: {},
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
    },
  },
  {
    name: "Miscellaneous",
    id: 6,
    fields: {
      target_days: {
        label: "Days Of Week",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
      target_hours: {
        label: "Day Of Hours",
        value: [],
        error: false,
        message: "",
        touched: false,
        required: false,
        type: "",
        default_msg: "",
      },
    },
  },
];
